import React from 'react'
import { connect } from 'react-redux'
import {
  withStyles,
  Button,
  Typography,
  CircularProgress,
  Dialog,
  CardContent,
  Card,
  FormControl,
  InputLabel,
  Input
} from '@material-ui/core'
import styles from './styles'
import { compose } from 'recompose'
import withDrawer from '../../components/withDrawer'
import MenuIcon from '@material-ui/icons/Menu'
import moment from 'moment'
import { doRefresh } from '../../actions/authentication'
import { isEmpty } from 'lodash'
import { endEvent, resetEvent, updateEvent, addEventAttendee } from '../../actions/events'
import PubNubReact from 'pubnub-react'
import ShowImage from '../../components/ShowImage'
import { TextMaskCustom } from '../../components/MaskedInput'
import { checkUserByPhone, createUser } from '../../actions/users'
import { uploadImage, sendPhotoID } from '../../actions/avatarImage'
import constants from '../../config/constant';
import { openSnackBar } from "../../actions/snack-bar";

const { ROLE } = constants;
class Timer extends React.Component {
  constructor(props) {
    super(props)
    this.pubnub = new PubNubReact({
      publishKey: process.env.REACT_APP_PUBNUB_PUB_KEY,
      subscribeKey: process.env.REACT_APP_PUBNUB_SUB_KEY
    })
    this.pubnub.init(this)
  }

  state = {
    firstName: '',
    lastName: '',
    delay: 0,
    timeout: 0,
    interval: null,
    eventIndex: null,
    gotTime: false,
    resetTime: '',
    contactsIndex: 0,
    pubNubMsg: '',
    pubNubUserId: '',
    mapURL: '',
    resetButtonReady: true,
    attendeeModal: false,
    newClientData: false,
    clientData: {
      phone: '',
      first_name: '',
      last_name: '',
      title: '',
      address: '',
      id: '',
      hasLicense: null,
      photo_id: ''
    },
    foundClientUser: null,
    addLicense: false,
    spinLicense: false,
    spinEnd: false,
    lat: '',
    lng: ''
  }

  componentDidUpdate(prevProps, prevState) {
    // restarts timer based on next contact
    const { events } = this.props.authentication.authenticatedUser
    const eventIndex = events.findIndex(
      x => x.id === +this.props.match.params.id
    )

    if (
      prevState.contactsIndex < this.state.contactsIndex
      // && this.props.authentication.authenticatedUser
    ) {
      clearInterval(this.state.interval)
      this.handleStartTimer()
    }

    if (
      !this.state.gotTime &&
      eventIndex > -1 &&
      events[eventIndex].start_time
    ) {
      // Starts Timer once async info ready
      this.setState({ gotTime: true, eventIndex })
      this.handleStartTimer()

      // sets map pic once info ready
      const { lat, lng } = events[eventIndex]
      this.setState({
        lat: lat,
        lng: lng
      })
      const mapsStaticURL = 'https://maps.googleapis.com/maps/api/staticmap?'
      const mapStyle = process.env.REACT_APP_MAP_STYLE
      let mapURL = `${mapsStaticURL}center=${lat},${lng}&zoom=16&size=130x130&markers=${lat},${lng}&key=${
        process.env.REACT_APP_GOOGLE_GEOENCODING_API_KEY
      }&style=${mapStyle}`

      this.setState({ mapURL })
    }
  }

  componentDidMount() {
    this.props.dispatch(doRefresh())
    this.pubnub.subscribe({
      channels: [`safeshowing-events-${+this.props.match.params.id}`],
      withPresence: true
    })

    this.pubnub.getMessage(
      `safeshowing-events-${+this.props.match.params.id}`,
      msg => {
        if (msg.message.text === 'Event timer reset') {
          this.props.dispatch(doRefresh()).then(e => {
            this.handleResetTimer()
          })
        } else {
          this.handleEndTimer()
          // this.setState({
          //   pubNubMsg: msg.message.text,
          //   pubNubUserId: msg.message.users_id
          // })
        }
      }
    )
  }

  componentWillUnmount() {
    clearInterval(this.state.interval)
    this.pubnub.unsubscribe({
      channels: [`safeshowing-events-${+this.props.match.params.id}`]
    })
  }

  handleStartTimer() {
    const {
      events,
      contacts,
      id: myID
    } = this.props.authentication.authenticatedUser
    const { contactsIndex } = this.state
    console.log(this.props.authentication.authenticatedUser, '>>>>>>>>>>events')
    const event =
      events[events.findIndex(x => x.id === +this.props.match.params.id)]
    console.log('event: ', event)

    let start_time

    if (event.iterations && !isEmpty(event.iterations)) {
      start_time = event.iterations[event.iterations.length - 1].created
    } else {
      start_time = event.start_time
    }
    const expiredMinutesSinceStart = moment
      .duration(moment().diff(moment.utc(start_time).local().format("YYYY-MM-DD HH:mm")))
      .as('minutes')
      .toFixed(3)
      console.log(expiredMinutesSinceStart, 'expiredMinutesSinceStart')
    const sortedContacts = contacts
      .sort((a, b) => a.delay - b.delay)
      .filter(contact => contact.users_id === myID)
    const firstContactDelay =
      sortedContacts.length === 0 ? 0 : sortedContacts[contactsIndex].delay
      console.log(firstContactDelay, 'contact6')

    const delay =
      firstContactDelay - expiredMinutesSinceStart <= 0
        ? 0
        : (firstContactDelay - expiredMinutesSinceStart).toFixed(2)

    this.setState({
      delay: event.delay_time !== "0.00" ? (Number(event.delay_time) - expiredMinutesSinceStart) * 60 : delay * 60,
      resetButtonReady: true
    }, () => {
      this.setState({
        interval: this.state.delay <= 0
        ? true
        : setInterval(() => {
            this.setState(prevState => ({ delay: prevState.delay - 1 }))
          }, 1000)
      })
    })
    // this.props.dispatch(doRefresh())
  }

  handleResetTimer = () => {
    this.setState({ attendeeModal: true })
  }

  handleReset = () => {
    const user = this.props.authentication.authenticatedUser
    const client = this.state.clientData
    const foundUser = this.state.foundClientUser
    console.log(user, 'user', foundUser, 'foundUser', client, 'users')
    if (user.license_required === 1) {
      if (foundUser && client.id && client.hasLicense) {
        this.handleUpdate()
      } else if (foundUser && client.id) {
        this.setState({ addLicense: true })
      } else {
        const reqData = this.state.clientData;
        reqData['role'] = ROLE.CONTACT;
        this.props
          .dispatch(createUser(reqData))
          .then(res => {
            const clientData = this.state.clientData
            clientData.id = res.id

            this.setState({
              clientData,
              foundClientUser: true
            })
          })
          .then(() => this.setState({ addLicense: true }))
      }
    } else {
      if (foundUser && client.id) {
        this.handleUpdate()
      } else {
        const reqData = this.state.clientData;
        reqData['role'] = ROLE.CONTACT;
        this.props
          .dispatch(createUser(reqData))
          .then(res => {
            const clientData = this.state.clientData
            clientData.id = res.id

            this.setState({
              clientData,
              foundClientUser: true
            })
          })
          .then(() => {
            this.handleReset()
          })
      }
    }
  }

  handleUpdate = () => {
    this.setState({ spinSubmit: true })
    navigator.geolocation.getCurrentPosition(async position => {
      const coords = position.coords
      const clientData = this.state.clientData
      this.props
        .dispatch(
          updateEvent(
            coords,
            this.state.clientData.id,
            this.props.match.params.id,
            coords.latitude,
            coords.longitude
          )
        )
        .then(res => {
          this.setState({
            resetButtonReady: false,
            contactsIndex: 0,
            attendeeModal: false,
            spinSubmit: false,
            newClientData: false,
            clientData: {
              phone: '',
              first_name: '',
              last_name: '',
              title: '',
              address: '',
              id: '',
              hasLicense: null,
              photo_id: ''
            },
            foundClientUser: null,
            spinLicense: false,
            addLicense: false
          })
          this.setState({
            resetButtonReady: true
          })
        })
        .catch(err => {
          this.setState({ spinSubmit: false })
        })
    }, error => {
      const clientData = this.state.clientData
      let newLat = this.state.lat
      let newLong = this.state.lng
      this.props
        .dispatch(
          updateEvent(
            { newLat, newLong },
            this.state.clientData.id,
            this.props.match.params.id,
            this.state.lat,
            this.state.lang
          )
        )
        .then(res => {
          this.setState({
            resetButtonReady: false,
            contactsIndex: 0,
            attendeeModal: false,
            spinSubmit: false,
            newClientData: false,
            clientData: {
              phone: '',
              first_name: '',
              last_name: '',
              title: '',
              address: '',
              id: '',
              hasLicense: null,
              photo_id: ''
            },
            foundClientUser: null,
            spinLicense: false,
            addLicense: false
          })
          this.setState({
            resetButtonReady: true
          })
        })
        .catch(err => {
          this.setState({ spinSubmit: false })
        })
      })
  }

  handleEndTimer = () => {
    this.setState({ spinEnd: true })
    clearInterval(this.state.interval)
    this.props
      .dispatch(endEvent(this.props.match.params.id))
      .then(() => {
        this.props.dispatch(doRefresh()).then(() => {
          this.setState({ spinEnd: false })
          this.props.history.push(
            '/showing/complete/' + this.props.match.params.id
          )
        })
      })
      .catch(err => {
        this.setState({ spinEnd: false })
        this.props.history.push(
          '/showing/complete/' + this.props.match.params.id
        )
      })
  }

  confirmClient = e => {
    let newData = this.state.clientData
    if (newData.phone.length === 14 && e.target.value.length === 13) {
      newData.phone = e.target.value
      newData.first_name = ''
      newData.last_name = ''
      this.setState({ foundClientUser: false })
    } else {
      newData.phone = e.target.value
    }
    this.setState({ clientData: newData })
    // Once number has req length check if in db, and set indicator toggles
    if (newData.phone.length >= 14) {
      this.props
        .dispatch(checkUserByPhone(newData.phone.replace(/\D/g, '')))
        .then(res => {
          let newData = this.state.clientData
          newData.first_name = res.first_name
          newData.last_name = res.last_name
          newData.id = res.id
          newData.hasLicense = Boolean(res.has_license)
          // console.log('checked', newData)
          this.setState({
            clientData: newData,
            foundClientUser: true
          })
        })
        .catch(err => {
          if (err.response.body.message === 'user does not exist') {
            let newData = this.state.clientData
            newData.hasLicense = false
            this.setState({
              foundClientUser: false,
              clientData: newData
            })
          }
        })
    }
  }

  sendLicenseToDatabase = async() => {
    let attendeeID = this.state.clientData.id
    let eventID = this.props.match.params.id
    await this.props.dispatch(
      sendPhotoID(this.state.clientData.photo_id, this.state.clientData.id)
    )
    this.props.dispatch(addEventAttendee(attendeeID, eventID))
        .then(res => {
          this.props.dispatch(doRefresh()).then(res => {
            this.props.dispatch(
              openSnackBar({
                message: "Showing Updated"
              })
            )
            this.setState({
              resetButtonReady: false,
              contactsIndex: 0,
              attendeeModal: false,
              spinSubmit: false,
              newClientData: false,
              clientData: {
                phone: '',
                first_name: '',
                last_name: '',
                title: '',
                address: '',
                id: '',
                hasLicense: null,
                photo_id: ''
              },
              foundClientUser: null,
              spinLicense: false,
              addLicense: false
            })
            this.setState({
              resetButtonReady: true
            })
          })
        })
        .catch(err => {
          this.setState({ spinSubmit: false })
        })

    this.setState({ newClientData: false,
      attendeeModal: false
    })
  }

  setLicenseToState = stringifiedPhotoData => {
    console.log('enter')
    let newData = this.state.clientData
    newData.photo_id = stringifiedPhotoData.photo_id
    newData.hasLicense = true
    this.setState({
      clientData: newData
    })
    setTimeout(() => {
      this.sendLicenseToDatabase()
      // this.handleReset()
    }, 200)
  }

  onDrop = file => {
    const clientData = this.state.clientData
    console.log(clientData, 'clientData')
    console.log(file, 'file')
    // this.setState({ spinLicense: true })
    this.props.dispatch(
      uploadImage(file.target.files[0], 'licensePhoto', this.setLicenseToState)
    )
  }

  render() {
    const {
      delay,
      contactsIndex,
      gotTime,
      interval,
      eventIndex = null,
      mapURL,
      resetButtonReady,
      clientData
    } = this.state
    const { classes, toggleDrawer, authentication } = this.props
    const { authenticatedUser } = authentication
    let { events = [], contacts, id: myID } = authenticatedUser
    contacts = contacts.filter(contact => contact.users_id === myID)
    let name, person
    if (
      eventIndex &&
      events[eventIndex].attendees[events[eventIndex].attendees.length - 1]
    ) {
      person =
        events[eventIndex].attendees[events[eventIndex].attendees.length - 1]
      name = { first_name: person.first_name, last_name: person.last_name }
    }
    let hours = 0
    let minutes = Math.floor(delay / 60)
    let seconds = parseInt(Math.round(delay - minutes * 60).toFixed(0), 10)

    if (minutes >= 60) {
      hours = Math.floor(minutes / 60)
      minutes -= hours * 60
    }
    if (((hours <= 0 && seconds <= 0 && minutes <= 0) || minutes === -1) && interval) {
      clearInterval(interval)
      this.setState({ interval: null })
      if (contactsIndex < contacts.length - 1 && gotTime) {
        this.setState({ contactsIndex: contactsIndex + 1 })
      } else {
        this.setState({ finished: true })
      }
    }
    minutes = minutes <= 0 ? '00' : minutes
    seconds =
      seconds <= 0 || (seconds === 60 && minutes === '00') ? '00' : seconds

    if (/^\d$/.test(seconds)) {
      seconds = '0' + seconds
    }
    if (/^\d$/.test(minutes)) {
      minutes = '0' + minutes
    }
    if (/^\d$/.test(hours) && hours !== 0) {
      hours = '0' + hours
    }

    let photo_id
    if (
      events &&
      events[eventIndex] &&
      events[eventIndex].attendees[events[eventIndex].attendees.length - 1]
    ) {
      photo_id =
        events[eventIndex].attendees[events[eventIndex].attendees.length - 1]
          .photo_id
    }

    const photoID =
      typeof photo_id === 'string' &&
      photo_id.length > 0 &&
      JSON.parse(photo_id) &&
      JSON.parse(photo_id).public_id
        ? JSON.parse(photo_id).public_id
        : ''

    const event =
      events[events.findIndex(x => x.id === +this.props.match.params.id)]

    return (
      <div className={classes.app}>
        <div className={classes.header}>
          <div style={{ width: '100vw', display: 'flex' }}>
            <MenuIcon className={classes.menu} onClick={() => toggleDrawer()} />
          </div>

          <div className={classes.photo}>
            <div>
              <div
                style={{
                  paddingTop: '30px',
                  paddingRight: '8px',
                  minHeight: '130px',
                  minWidth: '130px'
                }}
              >
                {mapURL && (
                  <img src={mapURL} alt="map" style={{ borderRadius: '4px' }} />
                )}
              </div>
              <Typography
                style={{
                  margin: '-70px',
                  color: 'rgba(240,240,240,0.7)',
                  paddingRight: '8px'
                }}
              >
                CURRENT LOCATION
              </Typography>
            </div>
            <div>
              <ShowImage
                style={{
                  paddingTop: '30px',
                  paddingLeft: '10px',
                  minHeight: '130px',
                  minWidth: '130px'
                }}
                publicID={photoID}
                crop="thumb"
                gravity="face"
                width="130"
                height="130"
              />
              {/* <Typography
                style={{
                  margin: '-70px',
                  color: 'rgba(240,240,240,0.7)',
                  paddingLeft: '10px'
                }}
              > */}
              <Typography
                style={{
                  paddingBottom: '10px',
                  // fontWeight: 'bold',
                  textTransform: 'uppercase',
                  color: 'rgba(240,240,240,0.7)',
                  margin: '-70px',

                  paddingLeft: '10px'
                }}
              >
                {name ? (name.first_name !== null ? name.first_name : '') + ' ' + (name.last_name !== null ? name.last_name : '') : 'No Client'}
              </Typography>
              {/* </Typography> */}
            </div>
          </div>
        </div>

        <div className={classes.body}>
          <Typography
            variant="h1"
            style={{
              color: 'rgba(240,240,240,0.7)',
              fontWeight: '500',
              fontFamily: 'Roboto'
            }}
          >
            {`${hours}:${minutes}:${seconds}` }
          </Typography>

          <Typography
            variant="body2"
            style={{
              color: 'rgba(240,240,240,0.7)'
              // fontWeight: '500',
              // fontFamily: 'Roboto'
            }}
          >
            {contacts[contactsIndex]
              ? `${contacts[contactsIndex].first_name} ${
                  contacts[contactsIndex].last_name
                } will be notified`
              : ''}
          </Typography>

          {resetButtonReady ? (
            <Button
              // variant="flat"
              // className="flatSecondary"
              style={{
                color: 'rgba(237,67,106,1)',
                backgroundColor: 'rgba(255,255,255,.5)',
                margin: '20px'
              }}
              onClick={() => {
                if (event && event.delay_time && Number(event.delay_time) > 0) {
                  this.setState({ attendeeModal: true, newClientData: true })
                } else {
                  this.handleResetTimer()
                }
              }}
              disabled={!resetButtonReady}
            >
              ADD CLIENT/LOCATION
            </Button>
          ) : (
            <CircularProgress
              style={{
                color: 'rgba(255,255,255,.5)',
                marginTop: '16px'
              }}
            />
          )}
        </div>

        <div>
          <Typography
            style={{
              color: 'rgba(240,240,240,0.7)',
              paddingBottom: '20px',
              position: 'fixed',
              bottom: '24%',
              left: '32%'
            }}
          >
            {this.state.pubNubMsg}
          </Typography>
        </div>

        <div
          style={{
            width: '100vw',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            marginTop: '30px'
          }}
        >
          {/* <Typography
            style={{
              color: 'rgba(240,240,240,0.7)',
              fontWeight: 'bold',
              marginBottom: '6px'
            }}
          >
            CLICK HERE TO END SHOWING
          </Typography> */}
          {/* <Typography
            color="secondary"
            style={{ paddingBottom: '10px', fontWeight: 'bold' }}
          >
            {name ? name.first_name + ' ' + name.last_name : ''}
          </Typography> */}
          <Button
            variant="contained"
            onClick={this.handleEndTimer}
            className={classes.footerButton}
            style={{
              color: 'rgba(237,67,106,1)',
              backgroundColor: '#fff',

              margin: 'auto',
              width: '50%',
              transform: 'scale(1.2)'
            }}
            disabled={this.state.spinEnd}
          >
            {this.state.spinEnd ? (
              <CircularProgress size={24} />
            ) : (
              'END SHOWING'
            )}
          </Button>
        </div>
        <Dialog
          open={this.state.attendeeModal}
          onClose={() => this.setState({ attendeeModal: false })}
        >
          <Card>
            <CardContent>Add Client / Update Location</CardContent>
            <CardContent>
              {this.state.addLicense
                ? "Take a picture of the client's license to add them to your showing"
                : 'Resetting the timer will restart the timer with either a new client or your current client'}
            </CardContent>
            {!this.state.newClientData ? (
              <CardContent>
                <div style={{ display: 'flex' }}>
                  <Button
                    variant="text"
                    color="primary"
                    onClick={() => {
                      console.log('clicked')
                      this.setState({
                        resetButtonReady: false,
                        contactsIndex: 0,
                        attendeeModal: false
                      })
                      console.log('making call')
                      this.props
                        .dispatch(
                          resetEvent(
                            this.props.match,
                            this.state.interval,
                            null,
                            this.state.lat,
                            this.state.lng,
                            this.props.location.state
                          )
                        )
                        .then(() => {
                          this.props.dispatch(doRefresh()).then(() => {
                            this.handleStartTimer()
                          })
                        })
                        .catch(err => {
                          console.log('ERRRRRRRROR: ', err)
                        })
                    }}
                  >
                    {'Reset Timer'}
                  </Button>
                  <div style={{ flexGrow: 1 }} />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.setState({ newClientData: true })
                    }}
                  >
                    New client
                  </Button>
                </div>
              </CardContent>
            ) : (
              <CardContent>
                {this.state.addLicense ? (
                  <React.Fragment>
                    <input
                      type="file"
                      onChange={e => this.onDrop(e, 'upload-photo-button')}
                      style={{
                        display: 'none'
                      }}
                      id="file-upload"
                    />
                    <div
                      className="client-card-actions"
                      style={{ marginTop: '20px' }}
                    >
                      <Button
                        color="primary"
                        onClick={() => this.setState({ addLicense: false })}
                      >
                        CANCEL
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          document.getElementById('file-upload').click()
                        }}
                      >
                        {this.state.spinLicense ? (
                          <CircularProgress
                            style={{ width: '20px', height: '20px' }}
                            color="secondary"
                          />
                        ) : (
                          'ADD LICENSE'
                        )}
                      </Button>
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="loginPhone">Client Phone</InputLabel>
                      <Input
                        autoFocus
                        type="tel"
                        name="loginPhone"
                        id="loginPhone"
                        value={this.state.clientData.phone}
                        inputComponent={TextMaskCustom}
                        onChange={this.confirmClient}
                      />
                    </FormControl>

                    <div className="client-card-names-wrapper">
                      <FormControl
                        style={{
                          margin: '10px 20px 0px 0px'
                        }}
                      >
                        <InputLabel htmlFor="registerFirstName">
                          First Name
                        </InputLabel>
                        <Input
                          type="text"
                          inputProps={{ required: true }}
                          name="registerFirstName"
                          value={this.state.clientData.first_name}
                          onChange={e => {
                            let newData = clientData
                            newData.first_name = e.target.value
                            this.setState({ clientData: newData })
                          }}
                          id="registerFirstName"
                          autoComplete="nope"
                          disabled={this.state.foundClientUser}
                        />
                      </FormControl>

                      <FormControl
                        style={{
                          margin: '10px 0px 0px 0px'
                        }}
                      >
                        <InputLabel htmlFor="registerLastName">
                          Last Name
                        </InputLabel>
                        <Input
                          type="text"
                          inputProps={{ required: true }}
                          name="registerLastName"
                          value={this.state.clientData.last_name}
                          onChange={e => {
                            let newData = clientData
                            newData.last_name = e.target.value
                            this.setState({ clientData: newData })
                          }}
                          id="registerLastName"
                          autoComplete="nope"
                          disabled={this.state.foundClientUser}
                        />
                      </FormControl>
                    </div>
                    <div
                      className="client-card-actions"
                      style={{ marginTop: '20px' }}
                    >
                      <Button
                        color="primary"
                        onClick={() => this.setState({ newClientData: false })}
                      >
                        CANCEL
                      </Button>

                      {this.state.foundClientUser ? (
                        <Button
                          variant="contained"
                          className="client-card-footerButton"
                          color="primary"
                          onClick={() => this.handleReset()}
                          disabled={
                            !(this.state.clientData.phone.length >= 14) &&
                            this.state.spinSubmit
                          }
                        >
                          {this.state.spinSubmit ? (
                            <CircularProgress
                              style={{ width: '20px', height: '20px' }}
                              color="secondary"
                            />
                          ) : (
                            'submit'
                          )}
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          className="client-card-footerButton"
                          color="primary"
                          onClick={() => this.handleReset()}
                          disabled={
                            !(
                              this.state.clientData.phone.length >= 14 &&
                              (this.state.clientData &&
                                this.state.clientData.first_name &&
                                this.state.clientData.last_name)
                            ) && this.state.spinSubmit
                          }
                        >
                          {this.state.spinSubmit ? (
                            <CircularProgress
                              style={{ width: '20px', height: '20px' }}
                              color="secondary"
                            />
                          ) : (
                            'submit'
                          )}
                        </Button>
                      )}
                    </div>
                  </React.Fragment>
                )}
              </CardContent>
            )}
          </Card>
        </Dialog>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication
  }
}
const mapActionsToProps = dispatch => {
  return {
    toggleDrawer: () => dispatch({ type: 'DRAWER_TOGGLED', payload: true }),
    dispatch
  }
}

export default withDrawer(
  compose(
    connect(
      mapStateToProps,
      mapActionsToProps
    ),
    withStyles(styles)
  )(Timer)
)
